<template>
    <div class="white_bg">
        <div class="search">
            <div class="brand">
                <div class="brand-title">品牌：</div>
                <div class="brand-item" :class="{ active: brand === '' }" @click="handleBrandClick('')">全部</div>
                <div v-for="item in brandLetter" :key="item.letter" class="brand-item"
                    :class="{ active: brand === item }" @click="handleBrandClick(item)">{{ item }}
                </div>
            </div>
            <div class="search-input">
                <input type="text" placeholder="搜索车型" v-model="keyword" @keyup="handleKeyword">
                <div class="search-icon"></div>
            </div>
        </div>

        <div class="model-list">
            <div class="model-item" v-for="(item, i) in (modelList)" :key="i">
                <div class="name">
                    <div class="brand-name">{{ item.brand.name }}</div>
                    <div class="model">
                        <div class="model-left">
                            <div class="model-title">车型：</div>
                            <div class="model-name">{{ item.name }}</div>
                        </div>
                        <div class="model-right" @click="handleCompareClick(item)">
                            <img v-if="isInCompareList(item.id)" src="//img.cy-cdn.com/ceping/compare-icon.png" />
                            <img v-else src="//img.cy-cdn.com/ceping/compare-icon-normal.png" />
                            <span style="margin-left: 6px;">对比</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="compare_box">
        <div class="compare_show_btn">
            <div class="compare_num">{{ contrastListRef?.length || 0 }}</div>
            <div class="compare_text">对比</div>
        </div>
        <div class="compare_list_box">
            <div class="compare_list">
                <div class="contrast_item flex_center flex_between" v-for="(item, index) in (contrastListRef)"
                    :key="index">
                    <span>{{ item.brand.name }} {{ item.name }}</span>
                    <el-icon style="cursor: pointer"><close-bold :color="'#96A6CA'"
                            @click.stop="delCompareCar(item)" /></el-icon>
                </div>
                <button class="to_page_btn" @click.self="toContrastPage">测评对比</button>
                <div class="show_compare_btn"></div>
            </div>
        </div>
    </div>
</template>


<script>
import { ref, computed } from 'vue'
import { getOtaBrandLetter, getOtaModel } from '@/api';
import { ElIcon, ElMessage } from "element-plus"
import { CloseBold } from "@element-plus/icons";
import { useRouter } from "vue-router";
import store from "@/store";
export default {
    components: {
        ElIcon,
        CloseBold,
    },
    setup() {
        const router = useRouter();
        const brand = ref('')
        const keyword = ref('')
        const brandLetter = ref([])
        const modelList = ref([])
        const contrastListRef = computed(() => store.state.compareCarDataOta);
        console.log('contrastListRef.value', contrastListRef.value)

        const handleBrandClick = (brandItem) => {
            brand.value = brandItem
            getModel()
        }
        const handleKeyword = () => {
            console.log(keyword.value)
            brand.value = ''
            getModel()
        }
        const getBrandLetter = async () => {
            const res = await getOtaBrandLetter()
            brandLetter.value = res.data.letter
        }
        const getModel = () => {
            getOtaModel({
                first_word: brand.value,
                keyword: keyword.value
            }).then(res => {
                modelList.value = res.data.list
            })
        }
        const handleCompareClick = (item) => {
            store.setCompareCarDataOta(item)
        }
        const delCompareCar = (item) => {
            store.deleteCompareCarDataOta(item.id);
        };
        const isInCompareList = (id) => {
            return contrastListRef.value?.some(item => item.id === id) || false;
        }
        const toContrastPage = () => {
            const data = store.getCompareCarDataOta();
            if (data && data.length > 0) {
                let ids = [];
                for (let item of data) {
                    ids.push(item.id);
                }
                console.log('location')
                //跳转到测评多个
                router.push({
                    path: "/service/otaCompare/detail",
                    query: {
                        ids: ids.join(","),
                    },
                });
            } else {
                ElMessage.error("请先选择车型!");
            }
        };
        getBrandLetter()
        getModel()
        return {
            brand,
            keyword,
            brandLetter,
            handleBrandClick,
            handleKeyword,
            modelList,
            handleCompareClick,
            delCompareCar,
            contrastListRef,
            isInCompareList,
            toContrastPage
        }
    },
}
</script>


<style lang="less" scoped>
.model-list {
    padding-left: 39px;
    padding-bottom: 30px;
    margin-top: 58px;

    .model-item {
        margin-bottom: 22px;
    }
}

.name {
    display: flex;
    align-items: center;

    .brand-name {
        width: 205px;
        border-bottom: 2px solid #1FBCBF;
        padding-bottom: 3px;
        font-weight: bold;
        font-size: 16px;
        color: #404E5B;
        font-style: normal;
    }


    .model {
        flex: 1;
        border-bottom: 1px solid #D4D4D4;
        padding-bottom: 6px;
        display: flex;
        font-size: 15px;
        color: #404E5B;
        line-height: 20px;
        font-style: normal;
        justify-content: space-between;

        .model-title {
            padding-left: 5px;
            color: #616161;
        }

        .model-name {
            font-weight: bold;
        }
    }

    .model-left {
        display: flex;
    }

    .model-right {
        cursor: pointer;
        font-size: 12px;
        color: #404E5B;
        display: flex;
        align-items: center;
    }
}

.white_bg {
    padding: 0 62px;
}

.search {
    padding-top: 54px;
    display: flex;

    .brand {
        min-width: 850px;
        height: 51px;
        background: #F6F9FD;
        border-radius: 2px;
        display: flex;
        align-items: center;

        .brand-title {
            font-weight: bold;
            font-size: 17px;
            color: #191919;
            font-style: normal;
            margin-left: 39px;
            margin-right: 15px;
        }

        .brand-item {
            font-size: 15px;
            color: #191919;
            font-style: normal;
            margin-right: 21px;
            cursor: pointer;


        }

        .active {
            background: #1FBCBF;
            border-radius: 1px;
            padding: 3px 8px;
            color: #FFFFFF;
        }

    }

    .search-input {
        margin-left: 29px;
        background-position: 179px center;
        display: flex;
        position: relative;
        border: 1px solid #D7D7D7;
        border-radius: 2px;
        width: 196px;
        height: 53px;




        input {
            width: 150px;
            border: none;
            appearance: none;
            outline: none;
            background: transparent;
            padding: 0 10px 0 30px;
            font-size: 14px;

            &::placeholder {
                color: #bebebe;
            }
        }

        .search-icon {
            position: absolute;
            right: 10px;
            width: 50px;
            height: 100%;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/ssh_20221229.png) no-repeat center center;
            background-size: 17px 17px;
            cursor: pointer;
        }
    }
}

.compare_box {
    position: fixed;
    right: 100px;
    bottom: 300px;
    z-index: 10;

    .compare_show_btn {
        cursor: pointer;
        width: 76px;
        height: 76px;
        border-radius: 50%;
        background: linear-gradient(180deg, #FFFFFF 0%, #F7F7F7 100%);
        box-shadow: 1px 2px 12px 0px rgba(0, 0, 0, 0.07);
        padding-top: 13px;
        text-align: center;

        .compare_num {
            height: 35px;
            font-size: 26px;
            color: #7D7D7D;
            line-height: 35px;
        }

        .compare_text {
            height: 16px;
            font-size: 14px;
            font-weight: bold;
            color: #05A6AA;
            line-height: 16px;
        }
    }

    .compare_list_box {
        position: absolute;
        top: 92px;
        left: 50%;
        transform: translateX(-50%);
        width: 230px;
        padding: 20px 10px 20px 20px;
        background: #fff;
        box-shadow: 1px 2px 12px 0px rgba(0, 0, 0, 0.07);
        border-radius: 5px 0 0 5px;
        font-size: 16px;
        color: #000;
        z-index: 100;

        &.hide {
            display: none;
        }

        .compare_list {
            .contrast_item {
                height: 46px;
                font-size: 14px;
                line-height: 1.2;
                background-color: #f9f9f9;
                border-radius: 5px;
                margin-bottom: 10px;
                padding: 0 10px;
            }
        }

        .to_page_btn {
            display: block;
            margin: 0 auto;
            font-size: 16px;
            color: #000;
            font-weight: bold;
            background: #1FBCBF;
            color: #fff;
            width: 70%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            outline: none;
            border-radius: 4px;
            border: none;
            cursor: pointer;
        }
    }
}
</style>